<template>
  <div>
    <el-dialog title="订单支付" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
      <!-- <div class="pay-list flex-r-center">
        <div
          class="pay-item flex-center-center"
          :class="index==activePay?'pay-item-active':''"
          v-for="(item, index) in payData"
          :key="index"
          @click="changePay(item,index)"
        >
          <img class="pay-icon" :src="item.img" alt />
          <div>{{ item.title }}</div>
        </div>
      </div>-->
      <div v-if="activePay == 0" class="qrcode-area ta-c">
        <div class="code-content">
          <div class="code-price">{{ totalPrice }} 元</div>
            <div class="code-tip">请使用<strong style="color: #0d90ff">{{payType}}</strong>扫码支付，剩余时间 00:{{ showMin }}:{{ showSec }}</div>
          <div class="code-img" v-loading="loading">
            <img v-if="codeImg" class="image-code" :src="codeImg" alt />
          </div>
        </div>
        <!-- <img class="image-pay-way mt10" src="@/assets/login/image-pay-way.png" alt /> -->
      </div>
      <div v-if="activePay == 1" class="rechange-area">
        <div class="rechange-title">
          <img class="icon-rechange" src="@/assets/login/icon-rechange.png" alt />
          您当前申领印章数量
          <span class="info-color">1</span>枚，需要使用
          <span class="info-color">1</span>张兑换码
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
          class="demo-ruleForm flex-dir-center">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="12">
              <el-form-item prop="phone" label="兑换码">
                <el-input v-model="ruleForm.phone" placeholder="请输入14位兑换码卡号">
                  <img class="icon-rechange-account" src="@/assets/login/icon-rechange-account.png" alt />
                  <!-- <i slot="prefix" class="el-input__icon el-icon-user-solid"></i> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="phone" label label-width="0px">
                <el-input v-model="ruleForm.phone" placeholder="请输入兑换码密码">
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="pay-bottom">
        <el-button class="cancel-button" @click="handleClose">取消支付</el-button>
        <!-- <el-button class="confirm-button" v-if="activePay == 1" type="primary" @click="handleClose">确认支付</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookie from "js-cookie";

export default {
    data() {
        return {
            dialogVisible: false,
            loading: false,
            chosenPay: {},
            activePay: 0,
            showMin: 15,
            showSec: 0,
            minutes: 15,
            seconds: 0,
            codeImg: "",
            payData: [
                {
                    img: require("@/assets/login/icon-scan-pay.png"),
                    title: "扫码支付",
                    value: "scan"
                },
                // {
                //   img: require("@/assets/login/icon-change-pay.png"),
                //   title: "兑换码支付",
                //   value: "change"
                // }
            ],
            countTimer: null,
            ruleForm: {},
            rules: {},
            chosenData: {},
            payType: "",
            tradeNo: "",
            orderTimer: null,
            type: '',
            sealData: [],
            totalPrice: 0,
            userId: null,
            businessCode: null
        };
    },
    computed: {
        user() {
            return this.$store.state.account.user
        },
        isLogin() {
            return this.user && this.user.userId
        }
    },
    mounted() {
        this.userId = this.$auth.getUserId() || this.user.userId
        this.businessCode = Cookie.get('businessCreditCode') || this.user.code
    },
    watch: {
        seconds: {
            handler(newVal) {
                this.showSec = this.num(newVal);
            }
        },
        minutes: {
            handler(newVal) {
                this.showMin = this.num(newVal);
            }
        }
    },
    methods: {
        show(payImg, payType, tradeNo, price) {
            this.timer();
            this.payType = payType;
            this.activePay = 0;
            this.codeImg = payImg;
            this.totalPrice = price;
            this.tradeNo = tradeNo;
            this.dialogVisible = true;

            this.orderTimer = setTimeout(() => {
                this.getOrderStatus();
            }, 3000);
        },
        num(n) {
            return n < 10 ? "0" + n : "" + n;
        },
        timer() {
            let _this = this;
            this.countTimer = setInterval(function () {
                if (_this.seconds === 0 && _this.minutes !== 0) {
                    _this.seconds = 59;
                    _this.minutes -= 1;
                } else if (_this.minutes === 0 && _this.seconds === 0) {
                    _this.seconds = 0;
                    if (this.countTimer) {
                        clearInterval(this.countTimer);
                    }

                    if (this.orderTimer) {
                        clearTimeout(this.orderTimer);
                        this.orderTimer = 0
                    }

                    _this.minutes = 15;
                    _this.seconds = 0;
                    //如果到15分钟了，就重新创建一个订单，然后继续倒计时
                    _this.createOrder();
                    _this.timer();
                } else {
                    _this.seconds -= 1;
                }
            }, 1000);
        },
        getOrderStatus() {
            if (!this.tradeNo) return

            if (this.orderTimer) {
                clearTimeout(this.orderTimer)
                this.orderTimer = 0
            }

            let params = {
                tradeNo: this.tradeNo
            };

            this.$http.post(this.$api.register.doTrackTrade, params, {
                "Content-Type": "multipart/form-data"
            }).then(res => {
                if (!this.dialogVisible) return

                if (res.data.code == 200) {
                    if (res.data.data === true) {
                        this.handleClose();
                        this.$router.push({path: "/userCenter/myPrivateSeal"});
                    } else {
                        //定时器
                        this.orderTimer = setTimeout(() => {
                            this.getOrderStatus();
                        }, 3000)
                    }
                } else {
                    this.handleClose();
                    this.$message.error(res.data.msg || '支付失败')
                }
            });
        },
        handleClose() {
            if (this.orderTimer) {
                clearTimeout(this.orderTimer);
                this.orderTimer = 0
            }

            if (this.countTimer) {
                clearInterval(this.countTimer);
                this.countTimer = 0
            }

            this.codeImg = "";
            this.minutes = 15;
            this.seconds = 0;
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.pay-list {
    .pay-item {
        width: 330px;
        height: 70px;
        margin: 0 10px;
        align-items: center;
        border-radius: 2px;
        border: 1px solid #dfe4ed;
        color: #999;
        background: #fff;
        cursor: pointer;

        .pay-icon {
            width: 40px;
            height: 40px;
            margin-right: 15px;
        }
    }

    .pay-item-active {
        border: 1px solid #1880ff;
        color: #1d76f9;
        background: url("~@/assets/login/icon-pay-chosen.png") no-repeat 101% 103% #eff6ff;
        background-size: 8%;
    }
}

.code-content {
    width: 309px;
    height: 332px;
    padding-top: 15px;
    margin: 20px auto 0;
    background: url("~@/assets/login/image-code.png") 100% 100% no-repeat;
    box-sizing: border-box;

    .code-price {
        margin-bottom: 5px;
        font-size: 24px;
        font-weight: 400;
        color: #ed3946;
    }

    .code-tip {
        font-size: 13px;
        color: #999;
        margin-bottom: 10px;
    }

    .code-img {
        height: 200px;
        // width: 166px;
        margin: 40px 25px 0;

        .image-code {
            width: 100%;
            height: 100%;
        }
    }
}

.image-pay-way {
    width: 342px !important;
    height: 34px !important;
}

.rechange-area {
    .rechange-title {
        box-sizing: border-box;
        width: 683px;
        height: 50px;
        margin: 30px auto 20px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: #fdf6eb;
        border-radius: 4px;
        border: 1px solid #faa000;
        color: #333;
    }

    .icon-rechange {
        width: 24px;
        height: 24px;
        margin-right: 16px;
    }

    .info-color {
        color: #faa000;
        margin: 0 5px;
    }

    .icon-rechange-account {
        width: 14px;
        height: 14px;
    }
}

.pay-bottom {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 39px !important;

    .cancel-button {
        width: 120px;
        height: 32px;
        margin: 0 10px;
        padding: 0;
        cursor: pointer;
        font-size: 14px;
        color: #555;
        border: 1px solid #c9c9c9;
        border-radius: 4px;
        background-color: #fff;
    }

    .confirm-button {
        width: 120px;
        height: 32px;
        margin: 0 10px;
        padding: 0;
        background: #407fff;
    }
}

::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
</style>
